import { ErrorType, OperationType, QueryError } from "../../types";
import { AdmissibilityFilePost } from "./models";
import fetchMsalBlob from "../fetchMsalBlob";
import fetchMsalJson from "../fetchMsalJson";

export const createAdmissibilityFile = async (
  admissibilityFilePost: AdmissibilityFilePost
): Promise<string | undefined> => {
  try {
    const params = new URLSearchParams({
      incidentid: admissibilityFilePost.incidentid,
      name: admissibilityFilePost.file.name,
      vdl_type: admissibilityFilePost.vdl_type.toString(),
    });

    const endpoint = `${
      process.env.REACT_APP_API_BASE_URL
    }/admissibility_file/?${params.toString()}`;

    const result = await fetchMsalBlob(
      "POST",
      endpoint,
      admissibilityFilePost.file,
      new Headers({
        "x-file-name": encodeURIComponent(admissibilityFilePost.file.name),
      })
    );
    if (!result) throw new QueryError(ErrorType.UNKNOWN, "Erreur inconnue.");

    if (result.status !== 200) {
      throw new QueryError(ErrorType.INTERNAL, await result.text());
    }

    return await result.text();
  } catch (e) {
    throw QueryError.TransformUnknown(
      e,
      "Fichier d'admissibilité",
      OperationType.CREATE
    );
  }
};
export const deleteAdmissibilityFile = async (
  vdl_fichierdadmissibiliteid: string
): Promise<void> => {
  try {
    const endpoint = `${process.env.REACT_APP_API_BASE_URL}/admissibility_file/${vdl_fichierdadmissibiliteid}`;
    const result = await fetchMsalJson("DELETE", endpoint);
    if (!result) throw new QueryError(ErrorType.UNKNOWN, "Erreur inconnue.");

    if (result.status !== 200) {
      throw new QueryError(ErrorType.INTERNAL, await result.text());
    }
  } catch (e) {
    throw QueryError.TransformUnknown(
      e,
      "Fichier d'admissibilité",
      OperationType.DELETE,
      vdl_fichierdadmissibiliteid
    );
  }
};

